import { memo } from "react";
import { darkenColor, Div, Text, useBooleanState, useTheme } from "react-better-html";

import { type Workspace } from "../../types/workspace";

import { useI18n } from "../../utils/i18n";

const propertiesInWorkspace: number = 0;

type WorkspaceCardProps = {
   workspace: Workspace;
   onClick?: (workspace: Workspace, event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

function WorkspaceCard({ workspace, onClick }: WorkspaceCardProps) {
   const theme = useTheme();
   const { t } = useI18n();

   const [isHovered, setIsHovered] = useBooleanState();

   return (
      <Div.box
         position="relative"
         width="100%"
         borderColor={workspace.color}
         borderColorHover={darkenColor(workspace.color, 0.4)}
         boxShadowHover={onClick ? theme.styles.boxShadow : undefined}
         overflow="hidden"
         cursor={onClick ? "pointer" : undefined}
         value={workspace}
         onClickWithValue={onClick}
         onMouseEnter={setIsHovered.setTrue}
         onMouseLeave={setIsHovered.setFalse}
      >
         <Div
            position="absolute"
            width="100%"
            height={isHovered ? 12 : 8}
            top={0}
            left={0}
            backgroundColor={workspace.color}
            transition={theme.styles.transition}
         />

         <Div.column gap={theme.styles.gap} marginTop={10}>
            <Text flex={1} fontSize={22} fontWeight={700}>
               {workspace.name}
            </Text>

            <Text fontSize={14} color={theme.colors.textSecondary}>
               {`${propertiesInWorkspace ?? 0} ${t((l) => (propertiesInWorkspace === 1 ? l.common.item : l.common.items))}`}
            </Text>
         </Div.column>
      </Div.box>
   );
}

export default memo(WorkspaceCard);
